<template>
  <div>
    <a-row type="flex" justify="center" align="top" class="product-box">
            <a-col :span="12">
        <span class="title left-title">国外展会名录</span>
        <div class="product-info">
            <a-row type="flex" justify="center" align="top" class="product-box">
              <a-col :span="12">
                <div class="box line">
                  <div>每周搜索次数</div>
                  <div>
                    <span>剩余次数</span>
                    <span :class="accountInfo.emailfinder.end_time!='-1'?'':'blue'">{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.end_time!='-1'?'不限':accountInfo.emailfinder.purchaser_search_times))||0}}</span>
                    <span>总额度 <span class="blue">{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.end_time!='-1'?'不限':accountInfo.emailfinder.purchaser_search_times_total))||0}}</span></span>
                  </div>
                  <div>
                    已使用  <span>{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.purchaser_search_times_total-accountInfo.emailfinder.purchaser_search_times))||0}}</span> 
                  </div>
                  <div>
                    已过期  <span>0</span> 
                  </div>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="box">
                  <div>查看展会名录详情</div>
                  <div>
                    <span>剩余条数</span>
                    <span class="blue">{{(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.purchaser_detail_times)||0}}</span>
                    <span>总额度 <span class="blue">{{(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.purchaser_detail_times_total)||0}}</span></span>
                  </div>
                  <div>
                    已使用 <span>{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.purchaser_detail_times_total-accountInfo.emailfinder.purchaser_detail_times))||0}}</span> 
                  </div>
                  <div>
                    已过期 <span>{{(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.out_date_purchaser_detail)||0}}</span> 
                  </div>
                </div>
              </a-col>
            </a-row>
        </div>
      </a-col>
      <a-col :span="12">
        <span class="title right-title">国外采购商</span>
        <div class="product-info">
            <a-row type="flex" justify="center" align="top" class="product-box">
              <a-col :span="12">
                <div class="box line">
                  <div>每周搜索次数</div>
                  <div>
                    <span>剩余次数</span>
                    <span :class="accountInfo.emailfinder.end_time!='-1'?'':'blue'">{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.end_time!='-1'?'不限':accountInfo.emailfinder.buy_purchaser_search_times))||0}}</span>
                    <span>总额度 <span class="blue">{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.end_time!='-1'?'不限':accountInfo.emailfinder.buy_purchaser_search_times_total))||0}}</span></span>
                  </div>
                  <div>
                    已使用  <span>{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.buy_purchaser_search_times_total-accountInfo.emailfinder.buy_purchaser_search_times))||0}}</span> 
                  </div>
                  <div>
                    已过期  <span>0</span> 
                  </div>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="box">
                  <div>查看采购商详情</div>
                  <div>
                    <span>剩余条数</span>
                    <span class="blue">{{(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.buy_purchaser_detail_times)||0}}</span>
                    <span>总额度 <span class="blue">{{(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.buy_purchaser_detail_times_total)||0}}</span></span>
                  </div>
                  <div>
                    已使用 <span>{{(accountInfo&&accountInfo.emailfinder&&(accountInfo.emailfinder.buy_purchaser_detail_times_total-accountInfo.emailfinder.buy_purchaser_detail_times))||0}}</span> 
                  </div>
                  <div>
                    已过期 <span>{{(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.out_date_buy_purchaser_detail)||0}}</span> 
                  </div>
                </div>
              </a-col>
            </a-row>
        </div>
      </a-col>
    </a-row>

    <p class="activeexhi">
      <a-button @click="ActiveExhi">升级权益</a-button>
      <br>
      <span class="deadline" v-if="accountInfo['emailfinder']&&!!accountInfo['emailfinder'].end_time">*账户有效期至{{accountInfo['emailfinder'].end_time=='-1'?'无限期':(moment.unix(accountInfo&&accountInfo.emailfinder&&accountInfo.emailfinder.end_time).format('YYYY年MM月DD日'))}}</span>
    </p>
  </div>
</template>

<script>
import ActiveExhibitor from "./ActiveExhibitor";
export default {
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    ActiveExhi() {
      //this.$dialog(ActiveExhibitor);
      this.$router.push({name:'product'})
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.product-box {
  .title {
    margin: 40px auto 0;
    font-size: 20px;
    // padding-left: 60px;
    text-align: center;
    line-height: 60px;
    height: 60px;
    display: block;
    border-top: 1px solid;
    border-bottom: 1px solid;
    &.left-title {
      border-image: linear-gradient(to right, #fff, #e9eef2) 1 1;
    }
    &.right-title {
      border-image: linear-gradient(to left, #fff, #e9eef2) 1 1;
    }
    &::before {
      content: " ";
      display: inline-block;
      width: 23px;
      height: 23px;
      @include intop-icon;
      background-position: -260px -660px;
      vertical-align: middle;
    }
  }
  .product-info {
    height: 250px;
    background: #fff;
    width: 460px;
    border-radius: 10px;
    color: #aeaeae;
    margin: 50px auto 0;
    .line{
      border-right:1px solid ;
      border-image: linear-gradient(#fff, #e9eef2, #e9eef2, #e9eef2, #fff) 1;
    }
    .box {
      .blue{
        color: #0b97e0 !important;
      }
      width: 230px;
      height: 250px;
      position: relative;
      text-align: center;
      &>div:first-child{
        margin-bottom: 10px;
        font-size: 16px;
        color: #666;
        font-weight: bold;
      }
      & > div:nth-child(2) {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background-color: #f7f7f7;
        margin: 0 auto;
        font-size: 18px;
        color: #666;
        padding: 10px;
        overflow: hidden;
        & > span {
          display: block;
          color: #c0c0c0;
          &:first-child{
            margin-top: 20px;
            font-size: 14px;
          }
          &:nth-child(2){
            font-size: 38px;
          }
          &:last-child{
            color: #666;
            font-weight: bold;
            width: 150px;
            height: 40px;
            font-size: 12px;
            background-color: #eceaea;
            margin-top: 10px;
            margin-left: -10px;
            padding-top: 4px;
          }
        }
      }
      & > div:nth-child(3),div:nth-child(4){
        margin-top: 20px;
        &>span{
          color: #c0c0c0;
          font-weight: bold;
        }
      }
      & > div:nth-child(4){
        margin-top: 10px;
      }
    }
    .deadline {
      text-align: center;
      font-size: 12px;
      margin-top: 15px;
    }
  }
}
.activeexhi {
  text-align: center;
  margin: 90px 0 0;
  & /deep/ .ant-btn {
    background: #e9f6fc;
    border-color: #b5e0f6;
    color: #0b97e0;
    font-size: 16px;
    font-weight: bold;
    height: 40px;
    width: 180px;
  }
  .deadline {
    text-align: center;
    font-size: 12px;
    margin-top: 15px;
    color: #aeaeae;
    display: inline-block;
  }
}
</style>